import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Flyout } from '../Flyout/Flyout.js';
import { TooltipWrapper, TooltipContainer, TooltipContent } from './Tooltip.styles.js';
import { getBoundingClientWithArrowShift } from './Tooltip.helpers.js';
import useRect from '../../hooks/useRect.js';

var Tooltip = function Tooltip(_ref) {
  var _getBoundingClientWit;
  var content = _ref.content,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top-centre' : _ref$placement,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 200 : _ref$delay,
    _ref$isCondensed = _ref.isCondensed,
    isCondensed = _ref$isCondensed === void 0 ? true : _ref$isCondensed,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var timeoutRef = useRef(null);
  var _useRect = useRect(100, [isOpen]),
    _useRect2 = _slicedToArray(_useRect, 2),
    triggerRef = _useRect2[0],
    triggerRect = _useRect2[1];
  var handleMouseEnter = function handleMouseEnter() {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(function () {
      setIsOpen(true);
    }, delay);
  };
  var handleMouseLeave = function handleMouseLeave() {
    clearTimeout(timeoutRef.current);
    setIsOpen(false);
  };
  var triggerRectWithShift = (_getBoundingClientWit = getBoundingClientWithArrowShift(triggerRect, placement)) !== null && _getBoundingClientWit !== void 0 ? _getBoundingClientWit : {};
  return React__default.createElement(TooltipWrapper, {
    ref: triggerRef,
    onFocus: handleMouseEnter,
    onBlur: handleMouseLeave,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, isOpen && React__default.createElement(Flyout, {
    disablePointerEvents: true,
    disableScrollWhenOpen: false,
    placement: placement,
    triggerPosition: triggerRectWithShift
  }, React__default.createElement(TooltipContainer, {
    $isCondensed: isCondensed,
    $placement: placement,
    role: "tooltip",
    "data-testid": testId
  }, React__default.createElement(TooltipContent, {
    as: "div"
  }, content))), children);
};
Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  delay: PropTypes.number,
  isCondensed: PropTypes.bool,
  placement: Flyout.propTypes.placement,
  testId: PropTypes.string
};

export { Tooltip, Tooltip as default };
//# sourceMappingURL=Tooltip.js.map
